module.exports = __webpack_public_path__ + "img/6.ed9ee2ce.jpg";